export enum ViewStateFilterStates {
    Expanded = 1,
    Collapsed = 2,
    Hidden = 3,
}

// export enum ViewStateFilterElevations {
//     SIDE = 'side',
//     OVER = 'over'
// }

export type ViewStateFilterElevations = 'side' | 'over';
